export const FormFeedback = {
  bindings: {
    isComplete: '<',
    onSubmit: '&',
  },

  template: `
    <div ng-hide="$ctrl.isComplete">
      <form
        name="form"
        ng-submit="$ctrl.onSubmit({ data: form.data })"
        novalidate>
        <p>
          We think you're 5 stars.<br>
          How many stars would you give us?
        </p>
        <form-input
          form="form"
          type="hidden"
          name="rating"
          value="form.data.rating">
        </form-input>
        <p>
          <rating-stars
            size="lg"
            rating="form.data.rating"
            is-enabled="true"
            on-click="form.data.rating = value">
          </rating-stars>
        </p>
        <div class="mb-4">
          <form-textarea
            custom-class="w-100 btn text-left rounded bg-gray-100"
            form="form"
            name="description"
            placeholder="Your comments here."
            rows="4"
            value="form.data.description">
          </form-textarea>
        </div>
        <div class="mb-2">
          <button-primary
            data-dismiss="modal"
            is-inverse="true">
            Cancel
          </button-primary>
          <button-primary ng-type="submit">
            Submit
          </button-primary>
        </div>
      </form>
    </div>
    <div ng-show="$ctrl.isComplete">
      <p>
        Thanks for taking the time to send your ratings and feedback to us,
        we're listening and will keep improving the program and experience on
        the Coaching Zone website.
      </p>
      <div class="d-flex justify-content-center border-0">
        <button-primary
          data-dismiss="modal"
          is-inverse="true">
          Close
        </button-primary>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/FormFeedback/FormFeedback.js